<template>
    <div>
        <div class="row" v-if="roles.is_student">
            <div class="col-md-8 col-md-offset-2">
                <div class="panel profile-panel profile-education">
                    <template v-if="hasEducations">
                        <h3 class="text-center tw-mb-10" v-text="$t('wi.education')"></h3>
                        <draggable @end="arrangeEducations" v-model="educationsData" :options="{disabled: roles.is_public, forceFallback: true}">
                            <div class="tw-mt-16" :class="{'tw-cursor-move' : ! roles.is_public}" v-for="education in educationsData">
                                <div class="tw-flex tw-justify-between tw-items-start tw-border-b tw-border-grey-light tw-pb-6 tw-mb-4">
                                    <div class="tw-flex tw-flex-col">
                                        <span class="tw-font-thin" v-if="education.metas[0].value.start_year && education.metas[0].value.graduation_year">{{ `${education.metas[0].value.start_year} - ${education.metas[0].value.graduation_year}` }}</span>
                                        <strong v-text="education.metas[0].value.school_name"></strong>
                                    </div>
                                    <div class="tw-flex tw-justify-end tw-items-center">
                                        <delete-button
                                                :item-id="education.id"
                                                type="educations"
                                                :message="`${$t('wi.sure_to_delete')} ${education.metas[0].value.school_name} ${$t('wi.from_your_profile')}`"
                                        />
                                        <edit-button
                                                modal-target="editEducation"
                                                :modal="{title: $t('wi.edit_school_info'), index: education.id}"
                                        />
                                    </div>
                                </div>
                                <div class="tw-mb-4">
                                    <span class="tw-mr-4" v-text="`GPA: ${education.metas[0].value.gpa}`"
                                          v-if="education.metas[0].value.gpa"></span>
                                    <span class="tw-mr-4" v-text="`SAT: ${education.metas[0].value.sat}`"
                                          v-if="education.metas[0].value.sat"></span>
                                    <span class="tw-mr-4" v-text="`ACT: ${education.metas[0].value.act}`"
                                          v-if="education.metas[0].value.act"></span>
                                </div>
                                <div class="tw-mb-4">
                                    <p v-text="education.metas[0].value.additional_information"></p>
                                </div>
                                <div v-if="education.metas[0].value.awards">
                                    <span>{{ $t('wi.awards') }}: </span><span v-text="education.metas[0].value.awards"></span>
                                </div>
                            </div>
                        </draggable>
                        <add-button
                                :title="$t('wi.add_school')"
                                :modal="{title: $t('wi.add_school')}"
                                modal-target="editEducation"
                        />
                    </template>
                    <empty-state
                            :title="$t('wi.education')"
                            :description="$t('wi.your_education_history')"
                            :button="{caption: $t('wi.add_education_info')}"
                            :modal="{title: $t('wi.add_school')}"
                            modalTarget='editEducation'
                            v-else
                    />
                </div>
            </div>
        </div>

        <div class="row" v-if="roles.is_super">
            <div class="col-md-8 col-md-offset-2">
                <div class="panel profile-panel profile-education.metas[0].value">
                    <h3 class="text-center tw-mb-10" v-text="$t('wi.education_experience')"></h3>
                    <div id="schools">
                        <table class="table table-condensed cursor-move no-border mg-top-20">
                            <thead class="border-bottom">
                            <tr>
                                <td colspan="2">
                                    <edit-button modal-target="editExperience"/>
                                    YYYY - YYYY<br>
                                    <strong>{{ $t('wi.educational_institution') }}</strong>
                                </td>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td colspan="2">{{ $t('wi.coaching_certification_levels') }}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <span v-if="roles.is_owner" class="btn-main-action btn-main-action--sm" data-toggle="tooltip"
                          data-placement="top" :data-title="$t('wi.add_education_experience')">
                        <span class="btn btn-primary btn-sm" data-toggle="modal" data-target="#editExperience"><i
                                class="fal fa-plus tw-align-middle" aria-hidden="true" :aria-label="$t('wi.add_more')"></i></span>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>
<script type="text/babel">
    import {mapGetters, mapMutations, mapActions} from 'vuex';
    import EditButton from './VisualElements/EditButton';
    import DeleteButton from './VisualElements/DeleteButton';
    import AddButton from './VisualElements/AddButton';
    import EmptyState from './EmptyState';
    import draggable from 'vuedraggable';

    export default {
        name: 'Academics',
        components: {
            EditButton,
            DeleteButton,
            EmptyState,
            AddButton,
            draggable
        },
        data() {
            return {}
        },
        computed: {
            ...mapGetters({
                educations: 'player-profile/educations',
                roles: 'player-profile/roles',
                profileData: 'player-profile/profile'
            }),
            hasEducations() {
                return this.educations.length > 0;
            },
            educationsData: {
                get() {
                    return this.profileData.educations;
                },
                set(educations) {
                    this.setEducations(educations);
                }
            }
        },
        methods: {
            ...mapMutations({
                setEducations: 'player-profile/setEducations'
            }),
            ...mapActions({
                updateOrder: 'player-profile/updateOrder'
            }),
            arrangeEducations() {
                let orders = this.profileData.educations.map(education => {
                    return {id: education.id}
                });

                this.updateOrder({
                    type: 'education',
                    orders
                })
            }
        }
    }
</script>
